/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取用户地区记录信息列表
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class GetMemberRecordRegionParams {
  constructor(public deviceId: string, public userId: string) {}
}

export default async function (
  params: GetMemberRecordRegionParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<member.GetMemberRecordRegionResponse>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/member-record-region/list`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
